export default __webpack_public_path__ + "static/media/dauntless.a0adfa96.png";